import React from 'react';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Gracias al equipo pude iniciar un proceso que marcó un antes y un después en mi vida.',
    initials: 'R.T.'
  }, {
    quote: 'Encontré apoyo, disciplina y acompañamiento durante mi proceso.',
    initials: 'P.F.'
  }, {
    quote: 'Agradezco al equipo clínico por su profesionalismo y apoyo durante mi tratamiento.',
    initials: 'A.O.'
  }];
  return <section className="py-16 md:py-24 bg-graySoft" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-269">
            Experiencias de personas que confiaron en Evolución Chile
          </h2>
          <p className="text-lg text-gray-600" data-id="element-270">
            La experiencia de otras personas puede entregar tranquilidad al
            momento de buscar orientación. En nuestra página principal puedes
            revisar reseñas de personas que han vivido su proceso junto a
            Evolución Chile.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" data-id="element-271">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-272">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-celeste-light opacity-50" data-id="element-273" />
              <p className="text-gray-700 italic mb-6 relative z-10" data-id="element-274">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-275">
                <div className="w-10 h-10 bg-azul rounded-full flex items-center justify-center text-white font-bold text-sm mr-3" data-id="element-276">
                  {testimonial.initials}
                </div>
                <span className="font-semibold text-gray-900" data-id="element-277">
                  — {testimonial.initials}
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-278">
          <p className="text-sm text-gray-500 italic" data-id="element-279">
            Testimonios resumidos desde reseñas públicas. Cada proceso es
            personal y puede variar según cada caso.
          </p>
        </div>
      </div>
    </section>;
}